import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

// Read shape of the Phase 2 Account Topic tab (view__account_topics): one
// account's topic-subscription matrix — the topic column set, the account
// row's live account_topics, and one row per comms-eligible contact with
// that contact's live contact_account_topics FOR THIS ACCOUNT. Validated
// before it reaches the tab (CLAUDE.md: validate every API response).

export const AccountTopicsTopicSchema = z
  .object({
    comms_topics__id: z.string(),
    comms_topics__label: z.string()
  })
  .strict()

export const AccountTopicsContactSchema = z
  .object({
    contacts__id: z.string(),
    contacts__first_name: z.string().nullable(),
    contacts__last_name: z.string().nullable(),
    contacts__email: z.string().nullable(),
    contact_account_topics__comms_topic_ids: z.array(z.string())
  })
  .strict()

export const AccountTopicsModelSchema = z
  .object({
    accounts__id: z.string(),
    accounts__name: z.string().nullable(),
    comms_topics: z.array(AccountTopicsTopicSchema),
    account_topics__comms_topic_ids: z.array(z.string()),
    contacts: z.array(AccountTopicsContactSchema)
  })
  .strict()

export const AccountTopicsModelFields = makeFieldKeys(AccountTopicsModelSchema)

export type AccountTopicsTopic = z.infer<typeof AccountTopicsTopicSchema>
export type AccountTopicsContact = z.infer<typeof AccountTopicsContactSchema>
export type AccountTopicsModel = z.infer<typeof AccountTopicsModelSchema>

export function validateAccountTopicsModel(data: unknown): AccountTopicsModel {
  try {
    return validateWithZodSchema(AccountTopicsModelSchema, data, 'account topics model')
  } catch (error) {
    throw new Error(`Account topics model validation failed: ${error}`)
  }
}
